import { createAction } from '@reduxjs/toolkit';

export const filterContact = createAction('contacts/filter');
